import React from "react";
import { object, shape, string, arrayOf } from "prop-types";
import EventsLandingPage from "../../organisms/EventsLandingPage";
import { useIsMobile } from "../../hooks/useIsMobile";

import "./conference-landing-page.m.css";

export const ConferenceLandingPage = ({ data, ...props }) => {
  const isMobile = useIsMobile();

  return (
    <EventsLandingPage
      data={data}
      eventType="conferences"
      className="conference-landing-page"
      isMobile={isMobile}
      showEventName={true}
      {...props}
    />
  );
};

ConferenceLandingPage.propTypes = {
  data: shape({
    collection: shape({
      name: string,
      summary: string,
      "hero-image-s3-key": string,
      "hero-image-metadata": object
    }),
    upcomingConferences: arrayOf(
      shape({
        id: string,
        headline: string,
        subheadline: string,
        "hero-image-s3-key": string,
        "hero-image-metadata": object,
        slug: string,
        attributes: shape({
          "event-date": string,
          "event-location": string
        })
      })
    ),
    previousConferences: arrayOf(
      shape({
        id: string,
        headline: string,
        subheadline: string,
        "hero-image-s3-key": string,
        "hero-image-metadata": object,
        slug: string,
        attributes: shape({
          "event-date": string,
          "event-location": string
        })
      })
    )
  })
};

export default ConferenceLandingPage;